import app from '@frontend/application-container';
import { FormNumber } from '@components/form';
import { ConsistencyChecksIcon } from '..';
import { SettingsEntry } from '../settings-entry';
import { img } from '@phi/components';
import { h } from 'vue';

export function AngleThreshold() {
    return SettingsEntry(
        'Angle threshold (in degrees)',

        '',

        img(ConsistencyChecksIcon, 'Angle threshold'),

        h(FormNumber, {
            value: app.state.smoothness_threshold_for_consistency_checks,
            'onUpdate:value': x => app.state.smoothness_threshold_for_consistency_checks = x,
            change: true,
        }),
    );
}
